import React from 'react';

const PriorityUp: React.FC<React.SVGProps<SVGSVGElement>> = () => {
  return (
    <svg
      width="6"
      height="14"
      viewBox="0 0 6 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 0.438354L0.113249 5.43835L5.88675 5.43835L3 0.438354ZM3.5 13.5616L3.5 4.93835L2.5 4.93835L2.5 13.5616L3.5 13.5616Z"
        fill="#D05B5B"
      />
    </svg>
  );
};

export default PriorityUp;
